module.exports = __webpack_public_path__ + "static/img/create-id.88bcaa1d.png";